// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609090904/js/" + chunkId + "." + {"44":"0b0f0fca","225":"d6fa98b3","481":"352ced97","486":"33ff51f4","770":"8a4f3a31"}[chunkId] + ".0.5531178031381153.chunk.js";
};